import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { IndicatorState } from '../../../models/indicator.models';
import { IndicatorStates } from '../../../constants/indicators.constants';
import { TranslocoDecimalPipe } from '@jsverse/transloco-locale';

@Component({
  selector: 'ui-temperature-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDecimalPipe],
  template: `
    <div
      class="ml-auto rounded-full border w-fit px-2 text-xs"
      [class]="stateClassMap[state()]"
    >
      @if (isDisabled() || !temperature()) {
        <span>--</span>
      } @else {
        <span>{{ temperature() | translocoDecimal:{ minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: false  } }}º</span>
      }
    </div>
  `,
})
export class TemperatureIndicatorComponent {
  state = input<IndicatorState>(IndicatorStates.Default);
  temperature = input<number>(0);

  isDisabled = computed<boolean>(() => this.state() === IndicatorStates.Disabled);

  stateClassMap: Record<IndicatorState, string> = {
    active: 'border-transparent text-black',
    disabled: 'border-transparent text-neutral-6',
    danger: 'bg-red-2 border-red-4 text-black',
  };
}
